import { useEffect, useRef } from 'react';

/**
 * Hook to run a callback only once
 * @param callback - The callback to run
 * @param runTrigger - Whether to run the callback (default: true)
 * @returns void
 */
export function useRunOnce(callback: () => void, runTrigger: boolean = true) {
  const hasRun = useRef(false);

  useEffect(() => {
    if (!hasRun.current && runTrigger) {
      callback();
      hasRun.current = true;
    }
  }, [runTrigger, callback]);
}
